import Vue from 'vue'
import Router from 'vue-router'
import WorkSpace from '@/appCenter/WorkSpace.vue'
import store from '@/store'
const AgentPage = ()=>import('@/appCenter/agent/AgentPage.vue')
const CustomerSupportAgentPage = ()=>import('@/appCenter/agent/CustomerSupportAgentPage.vue')
const dialogMode = ()=>import('@/appCenter/dialogMode.vue')
const workFlow = ()=>import('@/appCenter/workflow/workFlow.vue')
const appSelection = ()=>import('@/appCenter/appSelection/appSelection.vue')
const appManagement = ()=>import('@/appCenter/appManagement/appManagement.vue')
const AppList = ()=>import('@/appCenter/components/AppList.vue')
const workflowTemplate = ()=>import('@/appCenter/index/workflowTemplate.vue')
const cocobookllmDetail = ()=>import('@/appCenter/cocobookllm/detail.vue')
const testSpeech = ()=>import('@/appCenter/cocobookllm/testSpeech.vue')
const web = ()=>import('@/appCenter/web/index.vue')
const applicationCommunityPingShan = () => import('@/appCenter/applicationCommunityPingShan/applicationCommunityPingShan.vue')
const appCommunity = () => import('@/appCenter/appCommunity/appCommunity.vue')
const teachingModel = () =>import('@/appCenter/teachingMode/teachingMode.vue')
const cocobookllm = ()=>import('@/appCenter/cocobookllm/index.vue')
const learning = ()=>import('@/appCenter/learning/index.vue')
const createProject = ()=>import('@/appCenter/learning/component/createProject.vue')
const projectList = ()=>import('@/appCenter/learning/component/projectList.vue')
const studentProjectList = ()=>import('@/appCenter/learning/component/studentProjectList.vue')
const teacherProjectDetail = ()=>import('@/appCenter/learning/component/teacherProjectDetail.vue')
const studentProjectDetail = ()=>import('@/appCenter/learning/component/studentProjectDetail.vue')
const standalone = ()=>import('@/standalone/dialogMode/dialogMode.vue')
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name:'Home',
      component: WorkSpace
    },
    {
      path: '/WorkSpace',
      name: 'WorkSpace',
      component: WorkSpace
    },
    {
      path: '/AgentPage',
      name: 'AgentPage',
      component: AgentPage
    },
    {
      path: '/CustomerSupportAgentPage',
      name: 'CustomerSupportAgentPage',
      component: CustomerSupportAgentPage
    },
    {
      path: '/dialogMode',
      name: 'dialogMode',
      component: dialogMode
    },
    {
      path: '/workFlow',
      name: 'workFlow',
      component: workFlow
    },
    {
      path: '/appSelection',
      name: 'appSelection',
      component: appSelection
    },
    {
      path: '/appManagement',
      name: 'appManagement',
      component: appManagement
    },
    {
      path: '/AppList',
      name: 'AppList',
      component: AppList
    },
    {
      path: '/workflowTemplate',
      name: 'workflowTemplate',
      component: workflowTemplate
    },
    {
      path: '/cocobookllmDetail',
      name: 'cocobookllmDetail',
      component: cocobookllmDetail
    },
    {
      path: '/testSpeech',
      name: 'testSpeech',
      component: testSpeech
    },
    {
      path: '/web',
      name: 'web',
      component: web
    },
    {
      path:'/applicationCommunityPingShan',
      name:'applicationCommunityPingShan',
      component:applicationCommunityPingShan
    },
    {
      path:'/appCommunity',
      name:'appCommunity',
      component:appCommunity
    },
    {
      path:"/teachingModel",
      name:"teachingModel",
      component:teachingModel
    },
    {
      path:"/cocobookllm",
      name:"cocobookllm",
      component:cocobookllm
    },
    {
      path:"/learning",
      name:"learning",
      component:learning
    },
    {
      path:"/learning/createProject",
      name:"createProject",
      component:createProject,
      meta: {
        keepAlive: false
      }
    },
    {
      path:"/learning/projectList",
      name:"projectList",
      component:projectList,
      meta: {
        keepAlive: false
      }
    },
    {
      path:"/learning/studentProjectList",
      name:"studentProjectList",
      component:studentProjectList,
      meta: {
        keepAlive: false
      }
    },
    {
      path:"/learning/teacherProjectDetail",
      name:"teacherProjectDetail",
      component:teacherProjectDetail,
      meta: {
        keepAlive: true
      }
    },
    {
      path:"/learning/studentProjectDetail",
      name:"studentProjectDetail",
      component:studentProjectDetail,
      meta: {
        keepAlive: false
      }
    },
    {
      path:"/standalone",
      name:"standalone",
      component:standalone
    },
  ]
})
// 全局前置守卫 - 开始加载
router.beforeEach((to, from, next) => {
  // 显示全局 loading
  store.commit('set_global_loading', true)
  next()
})

// 全局后置守卫 - 加载完成
router.afterEach(() => {
  // 隐藏全局 loading
  store.commit('set_global_loading', false)
})

export default router
